import React from 'react';
import * as ImgLogoComercio from '@app/src/assets/img/logo-gec-dark-grey.svg';
import * as ImgLogoTrome from '@app/src/assets/img/logo-trome-dark-grey.svg';
import * as ImgLogoDepor from '@app/src/assets/img/logo-depor-dark-grey.svg';
// import * as ImgLogoPeru21 from '@app/src/assets/img/logo-peru-21-dark-grey.svg';
import { Allies } from './styled';

export const SectionOpportunity: React.FC = () => {
  return (
    <Allies>
      <img src={ImgLogoComercio} alt="Logo El Comercio" />
      <img src={ImgLogoTrome} alt="Logo El Trome" />
      <img src={ImgLogoDepor} alt="Logo Depor" />
      {/* <img src={ImgLogoPeru21} alt="Logo Peru21" /> */}
    </Allies>
  )
};